import { defineStore, getActivePinia } from 'pinia'

import { actions } from './actions'
import { getters } from './getters'
import { state } from './state'

export const commonStore = (gaApp) => {
  const init = defineStore('appCommon', {
    actions: actions(gaApp),
    getters: getters(gaApp),
    state,
  })

  return init(getActivePinia())
}
